// src/pages/ChangePasswordPage.js
import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import { fetchWithAuth } from "../utils/fetchWithAuth";
import FeedbackForm from "../components/FeedbackForm";
import {useAuth} from "../contexts/authContext";


const ChangePasswordPage = () => {
  const navigate = useNavigate();
  const [currentPw, setCurrentPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [message, setMessage] = useState("");
  const [showFeedback, setShowFeedback] = useState(false);
  const [userNickname, setUserNickname] = useState('');
  const { isLoggedIn, setIsLoggedIn, userEmail, setUserEmail } = useAuth();

  useEffect(() => {
    const nickname = localStorage.getItem("nickname");
    if (nickname) setUserNickname(nickname);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("nickname");
    localStorage.removeItem("usage_count");
    localStorage.removeItem("daily_limit");
    setIsLoggedIn(false);
    setUserEmail("");
    alert("로그아웃 되었습니다.");
    navigate("/login");
  };

  const handleSubmit = async () => {
    if (newPw.length < 6) {
      setMessage("새 비밀번호는 최소 6자 이상이어야 합니다.");
      return;
    }

    try {
      const res = await fetchWithAuth(`/user/change-password`, {
        method: "POST",
        body: JSON.stringify({
          current_password: currentPw,
          new_password: newPw,
        }),
      });

      if (res.ok) {
        setMessage("비밀번호가 성공적으로 변경되었습니다.");
        setTimeout(() => navigate("/mypage"), 1500);
      } else {
        const data = await res.json();
        setMessage(`❌ ${data.detail || "변경 실패"}`);
      }
    } catch (err) {
      setMessage("서버 오류가 발생했습니다.");
    }
  };

  return (
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-white">
        <header
            className="w-full flex flex-col md:flex-row justify-between items-center px-4 py-4 border-b bg-white dark:bg-gray-800">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <h1 className="text-xl font-bold text-blue-600 dark:text-blue-300">J_Universe</h1>

            <nav className="mt-2 text-sm">
              <Link to="/" className="hover:text-blue-400">J_Universe</Link>
              <span className="mx-2">|</span>
            </nav>
          </div>

          <div className="flex flex-col items-end gap-2 mt-4 md:mt-0">
            {isLoggedIn && (
                <div className="text-sm font-semibold text-green-300 text-center md:text-right w-full">
                  어서오세요, <span className="text-yellow-400">{userNickname}</span> 님
                </div>
            )}
            <div className="flex gap-2">
              {isLoggedIn ? (
                  <button
                      onClick={handleLogout}
                      className="px-4 py-2 text-sm font-semibold bg-red-500 text-white rounded-full">
                    Sign out
                  </button>
              ) : (
                  <Link
                      to="/login"
                      className="px-4 py-2 text-sm font-semibold bg-blue-500 text-white rounded-full">
                    Sign in
                  </Link>
              )}
               {!isLoggedIn && (
                <Link
                  to="/signup"
                  className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
                >
                  Sign up
                </Link>
              )}
              {isLoggedIn && (
                <Link
                  to="/mypage"
                  className="px-4 py-2 text-sm font-semibold text-white bg-green-500 rounded-full"
                >
                  MyPage
                </Link>
              )}
            </div>
          </div>
        </header>
        <div className="max-w-md mx-auto mt-10 p-6 bg-gray-300 rounded-lg shadow">
          <h2 className="text-xl text-black font-bold mb-4 text-center">🔑 비밀번호 변경</h2>

          <input
            type="password"
            placeholder="현재 비밀번호"
            className="w-full mb-3 p-2 border rounded"
            value={currentPw}
            onChange={(e) => setCurrentPw(e.target.value)}
          />

          <input
            type="password"
            placeholder="새 비밀번호"
            className="w-full mb-3 p-2 border rounded"
            value={newPw}
            onChange={(e) => setNewPw(e.target.value)}
          />

          <button
            onClick={handleSubmit}
            className="w-full py-2 bg-blue-500 text-white font-semibold rounded hover:bg-blue-600"
          >
            비밀번호 변경
          </button>

          {message && <p className="mt-4 text-center text-sm text-red-500">{message}</p>}
        </div>
    </div>
  );
};

export default ChangePasswordPage;
